export const COOKIES_AUTHORIZATION = 'authorization';
export const COOKIES_REFRESH_TOKEN = 'refresh_token';
